import React, { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faHome,
  faCircleCheck,
  faClock,
  faSignOutAlt,
  faCalculator,
  faUser,
  faPenToSquare,
  faDrawPolygon,
  faUserShield,
  faCoins,
  faClockRotateLeft,
  faArrowLeft,
  faArrowRight,
  faBriefcase,
  faSignInAlt,
  faCalendar,
  faTasks,
  faQuoteLeft,
  faMoneyBill1Wave,
  faDoorClosed,
  faDoorOpen,
  faCheckDouble,
  faCheckToSlot,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase.init";
import logo from "../Assets/logo.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Sidebar.css";
import { gapi } from "gapi-script";
import Notifications from "../Notifications/Notifications";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Modal as BootstrapModal, Button, Form } from "react-bootstrap";
import {
  doc,
  setDoc,
  addDoc,
  getDocs,
  query,
  collection,
  where,
} from "firebase/firestore";
import { db, storage } from "../../firebase.init";
import ClipLoader from "react-spinners/ClipLoader";
import ContactModal from "../ContactModal/ContactModal";
import { useUserRole } from "../../hooks/useUserRole";

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
  const [user, loadingAuth] = useAuthState(auth);
  const userData = useUserRole();
  const location = useLocation();
  const [hasOpenModal, setHasOpenModal] = useState(false);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= 768
  );
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      setHasOpenModal(false);
      return;
    }

    const checkForModal = () => {
      const bootstrapModalOpen =
        document.body.classList.contains("modal-open") ||
        document.querySelector(".modal.show");

      const reactModalOpen =
        document.querySelector(".ReactModal__Overlay--after-open");

      setHasOpenModal(
        Boolean(bootstrapModalOpen || reactModalOpen)
      );
    };

    checkForModal();

    const observer = new MutationObserver(checkForModal);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    return () => {
      observer.disconnect();
    };
  }, [isMobile]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setMobileOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (isMobile) {
      setMobileOpen(false);
    }
  }, [location.pathname, isMobile]);
  useEffect(() => {
    if (!isMobile) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = mobileOpen ? "hidden" : previousOverflow;

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobile, mobileOpen]);

  const handleSidebarToggle = () => {
    if (isMobile) {
      setMobileOpen((prev) => !prev);
    } else {
      toggleSidebar();
    }
  };

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [displayedText, setDisplayedText] = useState("");

  const [currentUserName, setCurrentUserName] = useState("");

  useEffect(() => {
    const fetchCurrentUserName = async () => {
      if (userData.ready && userData.user) {
        try {
          const userDoc = await getDocs(
            query(
              collection(db, "users"),
              where("uid", "==", userData.user.uid)
            )
          );

          if (!userDoc.empty) {
            const userData2 = userDoc.docs[0].data();
            setCurrentUserName(
              userData2.name || userData.user.email?.split("@")[0] || "User"
            );
          } else {
            setCurrentUserName(
              userData.user.displayName ||
              userData.user.email?.split("@")[0] ||
              "User"
            );
          }
        } catch (error) {
          console.error("Error fetching user name:", error);
          setCurrentUserName(
            userData.user.displayName ||
            userData.user.email?.split("@")[0] ||
            "User"
          );
        }
      } else if (!userData.ready) {
        setCurrentUserName("Loading...");
      } else {
        setCurrentUserName("Guest");
      }
    };

    fetchCurrentUserName();
  }, [userData.ready, userData.user]);

  const getUserDisplayName = () => {
    return currentUserName;
  };

  const logout = (e) => {
    e.preventDefault();
    signOut(auth);
    toast.info("Signing Out...", {
      toastId: "Signing",
      className: "red-toast",
      icon: (
        <FontAwesomeIcon
          icon={faSignOutAlt}
          bounce
          size="sm"
          style={{ color: "red" }}
        />
      ),
      progressClassName: "red-progress-bar",
    });
  };

  const getLinkClass = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/")
      ? "active"
      : "";

  if (loading)
    return (
      <div className="loading-container">
        <ClipLoader color="#b11111" size={60} />
        <div className="loading-text">
          {displayedText}
          <span className="cursor">|</span>
        </div>
      </div>
    );

  return (
    <>
      { }
      <div
        className={`mobile-appbar ${mobileOpen ? "menu-open" : ""
          } ${hasOpenModal ? "modal-hidden" : ""}`}
      >
        <Link to="/dashboard" className="mobile-appbar-brand">
          FireChecked.co.uk
        </Link>

        <button
          type="button"
          className={`mobile-sidebar-toggle ${mobileOpen ? "open" : ""}`}
          onClick={handleSidebarToggle}
          aria-label={
            mobileOpen ? "Close navigation menu" : "Open navigation menu"
          }
          aria-expanded={mobileOpen}
        >
          <FontAwesomeIcon icon={mobileOpen ? faXmark : faBars} />
        </button>
      </div>

      <div className="mobile-appbar-spacer" />

      {isMobile && mobileOpen && (
        <button
          type="button"
          className="mobile-sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
          aria-label="Close navigation menu"
        />
      )}

      <div
        className={`sidebar ${isCollapsed ? "collapsed" : ""} ${isMobile ? (mobileOpen ? "mobile-open" : "mobile-closed") : ""
          }`}
      >
        {!isMobile && (
          <div className="sidebar-header" style={{ minHeight: "100px" }}>
            {isCollapsed ? (
              <Link to="/" className="sidebar-link">
                <img
                  src={logo}
                  alt="logo"
                  className="logo"
                  style={{ maxWidth: "40px" }}
                />
              </Link>
            ) : (
              <Link to="/" className="sidebar-link">
                FireChecked.co.uk
              </Link>
            )}
          </div>
        )}

        <ul
          className="sidebar-menu"
          onClickCapture={(e) => {
            if (isMobile && e.target.closest("a")) {
              setMobileOpen(false);
            }
          }}
        >
          <li>
            <Link
              to={user ? "" : "#"}
              onClick={(e) => {
                if (!user) {
                  e.preventDefault();
                  setShowInviteModal(true);
                }
              }}
            >
              <FontAwesomeIcon icon={faUser} className="sidebar-icon" />
              <span>{getUserDisplayName()}</span>
            </Link>
          </li>

          <li className={getLinkClass("/dashboard")}>
            <Link to={"dashboard"}>
              <FontAwesomeIcon icon={faHome} className="sidebar-icon" />
              <span>Safety Dashboard</span>
            </Link>
          </li>

          {(userData.role === "admin" ||
            userData.role === "manager" ||
            userData.role === "inspection" ||
            userData.role === "reviewer" ||
            userData.role === "coordinator" ||
            userData.role === "remedial") && (
              <li className={getLinkClass("/tickets")}>
                <Link
                  to={user ? "/tickets" : "#"}
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faBriefcase} className="sidebar-icon" />
                  <span>My Work</span>
                  { }
                </Link>
              </li>
            )}

          {(userData.role === "admin" ||
            userData.role === "manager" ||
            userData.role === "inspection" ||
            userData.role === "coordinator" ||
            userData.role === "remedial" ||
            userData.role === "reviewer" ||
            userData.role === "client" ||
            userData.role === "inspector" ||
            userData.role === "carpenter") && (
              <li className={getLinkClass("/calendar")}>
                <Link
                  to={user ? "/calendar" : "#"}
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faCalendar} className="sidebar-icon" />
                  <span>Calendar</span>
                </Link>
              </li>
            )}

          {(userData.role === "admin" ||
            userData.role === "manager" ||
            userData.role === "inspection" ||
            userData.role === "coordinator") && (
              <li className={getLinkClass("/book-inspection")}>
                <Link
                  to="/book-inspection"
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faClock} className="sidebar-icon" />
                  <span>Book Inspection</span>
                </Link>
              </li>
            )}

          {(userData.role === "admin" ||
            userData.role === "manager" ||
            userData.role === "remedial" ||
            userData.role === "coordinator") && (
              <li className={getLinkClass("/book-remedial")}>
                <Link
                  to="/book-remedial"
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon
                    icon={faClockRotateLeft}
                    className="sidebar-icon"
                  />
                  <span>Book Remedial</span>
                </Link>
              </li>
            )}

          {(userData.role === "admin" ||
            userData.role === "inspection" ||
            userData.role === "remedial") && (
              <li className={getLinkClass("/estimates")}>
                <Link
                  to={user ? "/estimates" : "#"}
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faCalculator} className="sidebar-icon" />
                  <span>Estimates</span>
                </Link>
              </li>
            )}

          {(userData.role === "admin" ||
            userData.role === "manager" ||
            userData.role === "inspection" ||
            userData.role === "reviewer") && (
              <li className={getLinkClass("/review")}>
                <Link
                  to="/review"
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCheckToSlot}
                    className="sidebar-icon"
                  />
                  <span>Review Doors</span>
                </Link>
              </li>
            )}

          {(userData.role === "admin" ||
            userData.role === "manager" ||
            userData.role === "remedial") && (
              <li className={getLinkClass("/profit")}>
                <Link
                  to="/profit"
                  onClick={(e) => {
                    if (!user) {
                      e.preventDefault();
                      setShowInviteModal(true);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faCoins} className="sidebar-icon" />
                  <span>Profit Analysis</span>
                </Link>
              </li>
            )}

          {(userData.role === "admin" || userData.role === "annotator") && (
            <li className={getLinkClass("/annotate-images")}>
              <Link
                to="/annotate-images"
                onClick={(e) => {
                  if (!user) {
                    e.preventDefault();
                    setShowInviteModal(true);
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  className="sidebar-icon"
                />
                <span>Annotate Images</span>
              </Link>
            </li>
          )}

          {userData.role === "admin" && (
            <li className={getLinkClass("/admin")}>
              <Link to="/admin">
                <FontAwesomeIcon icon={faUserShield} className="sidebar-icon" />
                <span>Admin</span>
              </Link>
            </li>
          )}
          {user && (
            <li>
              <Link to="/" onClick={logout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="sidebar-icon" />
                <span>Logout</span>
              </Link>
            </li>
          )}

          {!user && (
            <li>
              <Link to="/login">
                <FontAwesomeIcon icon={faSignInAlt} className="sidebar-icon" />
                <span>Login</span>
              </Link>
            </li>
          )}
        </ul>

        <button className="collapse-btn" onClick={handleSidebarToggle}>
          <FontAwesomeIcon icon={isCollapsed ? faArrowRight : faArrowLeft} />
        </button>

        <ContactModal
          show={showInviteModal}
          onClose={() => setShowInviteModal(false)}
        />
      </div>
    </>
  );
};

export default Sidebar;
